import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  mainContainer: {
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    marginBottom: 2,
    margin: '0 auto',
  },
});
